import { format } from "date-fns";
import { ColumnDef } from "@tanstack/react-table";
import { GovernanceDataTable } from "@/components/governance/GovernanceDataTable";
import { CommitteeMember, TermsOfReference } from "@/types/governance";

interface TorVersionHistoryProps {
  tor: TermsOfReference;
  members: CommitteeMember[];
}

export function TorVersionHistory({ tor, members }: TorVersionHistoryProps) {
  const memberById = new Map(members.map((member) => [member.id, member]));
  const rows = tor.versionHistory.map((entry) => ({
    id: entry.id,
    version: entry.version,
    date: format(new Date(entry.date), "MMM d, yyyy"),
    updatedBy: memberById.get(entry.updatedBy)?.name || "Unknown",
    comments: entry.comments,
  }));

  const columns: ColumnDef<(typeof rows)[number]>[] = [
    {
      accessorKey: "version",
      header: "Version",
    },
    {
      accessorKey: "date",
      header: "Date",
    },
    {
      accessorKey: "updatedBy",
      header: "Updated By",
    },
    {
      accessorKey: "comments",
      header: "Comments",
    },
  ];

  return (
    <GovernanceDataTable columns={columns} data={rows} emptyMessage="No version history yet." minWidthClassName="min-w-[620px]" />
  );
}
